export const ComplementaryBcIds = {
  AVC: "1355",
} as const;

const complementarySet = new Set<string>(Object.values(ComplementaryBcIds));

export const getComplementaryAttribute = (product: string) => {
  return complementarySet.has(product) ? "Yes" : "No";
};
